// Photo filenames for 10th Anniversary Party
const ANNIVERSARY_PHOTOS_10TH = [
  "old-school-10th-anniv-party-10_16373105196_z.jpg",
  "old-school-10th-anniv-party-11_16211684270_z.jpg",
  "old-school-10th-anniv-party-12_16397341211_l.jpg",
  "old-school-10th-anniv-party-13_16211684190_l.jpg",
  "old-school-10th-anniv-party-14_16211447158_l.jpg",
  "old-school-10th-anniv-party-15_16373104956_l.jpg",
  "old-school-10th-anniv-party-16_16373104826_l.jpg",
  "old-school-10th-anniv-party-17_16373104746_l.jpg",
  "old-school-10th-anniv-party-18_16399090835_l.jpg",
  "old-school-10th-anniv-party-19_16211446648_l.jpg",
  "old-school-10th-anniv-party-20_16398164302_l.jpg",
  "old-school-10th-anniv-party-21_16213178307_l.jpg",
  "old-school-10th-anniv-party-22_15779051463_l.jpg",
  "old-school-10th-anniv-party-24_15776622234_l.jpg",
  "old-school-10th-anniv-party-25_16213178037_l.jpg",
  "old-school-10th-anniv-party-26_16213177887_l.jpg",
  "old-school-10th-anniv-party-27_16211683100_l.jpg",
  "old-school-10th-anniv-party-28_16397340011_l.jpg",
  "old-school-10th-anniv-party-29_16211446098_l.jpg",
  "old-school-10th-anniv-party-30_16398163662_l.jpg",
  "old-school-10th-anniv-party-31_15779050833_c.jpg",
  "old-school-10th-anniv-party-32_16373103726_l.jpg",
  "old-school-10th-anniv-party-33_16212850919_l.jpg",
  "old-school-10th-anniv-party-34_16373103566_l.jpg",
  "old-school-10th-anniv-party-35_16212850719_l.jpg",
  "old-school-10th-anniv-party-36_16212850589_l.jpg",
  "old-school-10th-anniv-party-37_16212850529_l.jpg",
  "old-school-10th-anniv-party-38_16399089505_l.jpg",
  "old-school-10th-anniv-party-39_15779050163_l.jpg",
  "old-school-10th-anniv-party-40_16373102866_l.jpg",
  "old-school-10th-anniv-party-1_16399091875_z.jpg",
  "old-school-10th-anniv-party-2_15779052843_l.jpg",
  "old-school-10th-anniv-party-3_16373105656_l.jpg",
  "old-school-10th-anniv-party-4_16213179267_l.jpg",
  "old-school-10th-anniv-party-5_15779052643_z.jpg",
  "old-school-10th-anniv-party-6_15776623304_c.jpg",
  "old-school-10th-anniv-party-7_16212852659_z.jpg",
  "old-school-10th-anniv-party-8_15779052533_l.jpg",
  "old-school-10th-anniv-party-9_16213179087_z.jpg"
];

export default ANNIVERSARY_PHOTOS_10TH;
